import React, { useContext } from 'react'
import Context from '../../context/Context'
import { Link } from 'react-router-dom'

const Swish = () => {
  const context = useContext(Context)

  if (context.organizationSettings.isSwishActive === '1') {
    return (
      <div className="row mt-2">
        <div className="col-12 text-center">
          <Link
            style={context.style.button}
            to={'swish' + context.url}
            className="btn btn-primary custom-btn-payment">
              Swish
          </Link>
        </div>
      </div>
    )
  }

  return ''
}

export default Swish
